'use client'

import { Skeleton } from '@/components/ui/skeleton';

const TicketSelectionSkeleton = () => {
  return (
    <div className='w-full bg-transparent mb-4'>
      <div className='mx-auto max-w-2xl flex flex-col justify-center gap-2'>
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className='rounded-xl border bg-white p-4'
          >
            <div className='flex justify-between items-baseline gap-2'>
              <Skeleton className='h-6 w-1/2' />
              <Skeleton className='h-4 w-1/4' />
            </div>

            <div className='mt-2 pb-2 flex justify-between items-center border-gray-200'>
              <Skeleton className='h-7 w-1/4' />
              <Skeleton className='h-10 w-20 rounded-lg' />
            </div>

            <div className='space-y-2 mt-1 pt-3 border-t'>
              <Skeleton className='h-4 w-full' />
              <Skeleton className='h-4 w-5/6' />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketSelectionSkeleton;